import React from 'react';
import { MasterExportContainerWithDocuments } from 'common/entity/documents';

class VehicleExportContainer extends React.PureComponent {
    getAdditionalColumns = columnAccessors => {
        const columnAccessorsCopy = [...columnAccessors];
        const startLocationColumns = [
            'baseLocations.startLocation.latLng',
            'baseLocations.startLocation.address'
        ];
        const endLocationColumns = [
            'baseLocations.endLocation.latLng',
            'baseLocations.endLocation.address'
        ];
        const startLocationIndex = columnAccessorsCopy.indexOf('startLocation');
        if (startLocationIndex > -1) {
            columnAccessorsCopy.splice(
                startLocationIndex,
                1,
                ...startLocationColumns
            );
        }
        const endLocationIndex = columnAccessorsCopy.indexOf('endLocation');
        if (endLocationIndex > -1) {
            columnAccessorsCopy.splice(
                endLocationIndex,
                1,
                ...endLocationColumns
            );
        }
        return columnAccessorsCopy;
    };

    render() {
        return (
            <MasterExportContainerWithDocuments
                {...this.props}
                getAdditionalColumns={this.getAdditionalColumns}
            />
        );
    }
}

export default VehicleExportContainer;
